import { render, staticRenderFns } from "./packages-details-modal.vue?vue&type=template&id=88deb032&"
import script from "./packages-details-modal.vue?vue&type=script&lang=js&"
export * from "./packages-details-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports